module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/de/nils-7966f7cc6dcb8a22a1e17d71850c27da.jpg";